import type { ComponentProps } from "react"
import { type VariantProps } from "class-variance-authority"
import cn from "@/v2-ui/utils/utils.cn"
import { buttonBaseVariants } from "@/v2-ui/button/base/button.base.constants"
import { AlertDialogAction as AlertDialogActionBase } from "./base/AlertDialogBase"

export type AlertDialogActionProps = ComponentProps<
  typeof AlertDialogActionBase
> &
  VariantProps<typeof buttonBaseVariants>

function AlertDialogAction(props: AlertDialogActionProps) {
  const { className, ...alertDialogActionBaseProps } = props
  return (
    <AlertDialogActionBase
      className={cn(
        "ui-alert-dialog-action",
        buttonBaseVariants({ className }),
      )}
      {...alertDialogActionBaseProps}
    />
  )
}

export default AlertDialogAction
